import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import getTimeZoneFormat from '../../../shared/utils/getTimeZoneFormat';
import { withWidgetSettings, widgetSettingsShape } from '../../../shared/components/WidgetSettings';
import CalendarTime from '../../../shared/components/CalendarTime';
import WidgetLink from '../../../shared/components/WidgetLink';
import { DATE_FORMAT, WIDGET_SCHEDULING } from '../../../shared/constants';

import style from './ProviderCardOpenings.scss';
import { intlShape } from '../../../shared/shapes';
import { formatDate } from '../../../shared/utils/formatCalendarTime';

const ProviderCardOpenings = ({
  providerUrl,
  nextAvailableUrl,
  startingDate,
  timeZone,
  widgetSettings,
  isOnWidget = false,
  toWidget = false,
  intl,
}) => {
  const timeZoneFormat = getTimeZoneFormat(timeZone);

  return (
    <div className={style['provider-card-openings']}>
      <section
        className={style['provider-card-openings__availibility']}
        data-qa="provider-card__availibility"
      >
        <p>
          <WidgetLink href={providerUrl} isOnWidget={isOnWidget} toWidget={toWidget}>
            Accepting scheduling online
          </WidgetLink>
          <br />
          Openings starting{' '}
          {formatDate(intl, startingDate, timeZoneFormat, {
            intl: DATE_FORMAT.MEDIUM_NO_YEAR,
            fallback: DATE_FORMAT.MEDIUM_NO_YEAR_FALLBACK,
          })}
          .
        </p>
      </section>
      <div
        className={style['provider-card-openings__next-opening']}
        data-qa="provider-card__next-opening"
      >
        <p>
          Next Opening{' '}
          <WidgetLink
            href={nextAvailableUrl}
            itemProp="url"
            isOnWidget={isOnWidget}
            toWidget={widgetSettings.scheduling === WIDGET_SCHEDULING.IN_WIDGET}
          >
            <CalendarTime datetime={startingDate} timeZone={timeZone} />
          </WidgetLink>
        </p>
      </div>
    </div>
  );
};

ProviderCardOpenings.propTypes = {
  providerUrl: PropTypes.string.isRequired,
  nextAvailableUrl: PropTypes.string.isRequired,
  startingDate: PropTypes.shape({
    toISOString: PropTypes.func.isRequired,
  }).isRequired,
  timeZone: PropTypes.string,
  // eslint-disable-next-line react/no-typos
  widgetSettings: widgetSettingsShape.isRequired,
  isOnWidget: PropTypes.bool,
  toWidget: PropTypes.bool,
  intl: intlShape,
};

export default injectIntl(withWidgetSettings()(ProviderCardOpenings));
